<template>
  <div class="container">
    <div class="header-title">
        <span style="position: absolute;left: 2.2rem;top: 1.5rem;" @click="backUp"><van-icon name="revoke"></van-icon></span>
    分享收益
    </div>
    <div class="sub-continner" style="margin-top: 7.8rem;">
      <div class="main-card">
        <div class="main-card-content">
          <!-- 提示： 分享收益赚钱！师傅享有2级推广收益：1级徒弟完成订单奖励2元，2级徒弟完成订单奖励1元。 -->
          提示：{{ shareTips }}
        </div>
      </div>
    <van-row gutter="2">
      <van-row gutter="2">
        <van-col span="24">
          <van-divider dashed style="margin: 1px"></van-divider>
        </van-col>
      </van-row>
      <van-row gutter="0">
        <van-col span="24">
          <van-tabs type="card" class="selectTab" @click="tabChange">
            <van-tab>
              <template #title>
                <div style="width:100%;height: 60px;text-align: center;margin: 2px;">
                  <van-icon size="24" name="qr"/>
                  <div style="font-size: small">我的邀请码</div>
                </div>
              </template>
              <div>
                <van-divider style="margin: 1px"></van-divider>
                <van-row gutter="0" style="background-color: #acacac;font-size:small;padding: 5px;color: gray">
                  <van-col span="12">
                    <div style="width: 100%;margin-left: 5%">
                      <span>邀请链接</span>
                    </div>
                  </van-col>
                  <van-col span="12">
                    <div style="width: 100%;text-align: right;" @click="handleRefrash">
                      <span style="margin-right: 5%">刷新</span>
                    </div>
                  </van-col>
                </van-row>
                <van-row gutter="2">
                  <van-col span="24">
                    <div
                        style="font-size: smaller;color: black;word-break:break-all; word-wrap: break-word; overflow:auto;margin: 10px">
                      {{ InviteCodeStr }}
                    </div>
                  </van-col>
                </van-row>
                <van-divider style="margin: 1px"></van-divider>
                <van-row gutter="2">
                  <van-col span="24">
                    <van-button size="default" type="info" style="width: 100%"
                                v-clipboard:copy="text"
                                v-clipboard:success="onCopy"
                                v-clipboard:error="onError">点击复制</van-button>
                    <div style="background-image: url('../../assets/img/share_1.png');text-align: center">
                      <vue-qr :logoSrc="imageUrl" :text="text" :size="200"></vue-qr>
                    </div>
                  </van-col>
                </van-row>
              </div>
            </van-tab>
            <van-tab>
              <template #title>
                <div style="width:100%;height: 60px;text-align: center;margin: 2px;">
                  <van-icon size="24" name="share-o"/>
                  <div style="font-size: small">我的推荐</div>
                </div>
              </template>
              <div style="margin: 10px;">
                <mt-navbar v-model="selected">
                  <mt-tab-item id="1">
                    <span>一级列表</span>
                    <span style="color: red;">(共{{oneLevers.length}}人)</span>
                  </mt-tab-item>
                  <mt-tab-item id="2">
                    <span>二级列表</span>
                    <span style="color: red;">(共{{twoLevers.length}}人)</span>
                  </mt-tab-item>
                </mt-navbar>
                <div class="header"></div>
                <mt-tab-container v-model="selected">
                  <mt-tab-container-item id="1">
                    <div class="tab-content-wrapper">
                      <div class="benefit-loading-mask" v-if="oneLeverLoading">
                        <van-loading size="20" type="spinner" color="#1989fa" />
                      </div>
                      <van-cell style="font-size: smaller" v-for="item in oneLevers" :key="item.customerId">
                      <template #title>
                        <van-row>
                          <van-col span="12">
                            <span>{{item.userStatus=='未审核'?"未完善资料":"资料已完善"}}({{item.customerName}})</span>
                          </van-col>
                          <van-col span="12">
                            <div style="width: 100%;text-align: right">
                              <van-tag>{{item.userStatus}}</van-tag>
                            </div>
                          </van-col>
                        </van-row>
                        <van-row>
                          <van-col span="24">
                            <span style="color: gray">邀请时间：{{ item.inviteDatetime }}</span>
                          </van-col>
                        </van-row>
                        <van-row>
                          <van-col span="24">
                            <span style="color: gray">完成任务数：{{ item.orderFinishNums }}</span>
                          </van-col>
                        </van-row>
                      </template>
                    </van-cell>
                    </div>
                  </mt-tab-container-item>
                  <mt-tab-container-item id="2">
                    <div class="tab-content-wrapper">
                      <div class="benefit-loading-mask" v-if="twoLeverLoading">
                      <van-loading size="20" type="spinner" color="#1989fa" />
                    </div>
                    <van-cell style="font-size: smaller" v-for="item1 in twoLevers" :key="item1.customerId">
                      <template #title>
                        <van-row>
                          <van-col span="12">
                            <span>{{item1.userStatus=='未审核'?"未完善资料":"资料已完善"}}({{item1.customerName}})</span>
                          </van-col>
                          <van-col span="12">
                            <div style="width: 100%;text-align: right">
                              <van-tag>{{item1.userStatus}}</van-tag>
                            </div>
                          </van-col>
                        </van-row>
                        <van-row>
                          <van-col span="24">
                            <span style="color: gray">邀请时间：{{ item1.inviteDatetime }}</span>
                          </van-col>
                        </van-row>
                        <van-row>
                          <van-col span="24">
                            <span style="color: gray">完成任务数：{{ item1.orderFinishNums }}</span>
                          </van-col>
                        </van-row>
                      </template>
                    </van-cell>
                    </div>
                  </mt-tab-container-item>
                </mt-tab-container>
              </div>
            </van-tab>
          </van-tabs>
        </van-col>
      </van-row>
    </van-row>
    </div>
  </div>
</template>

<script>
import vueQr from 'vue-qr'
import {queryIsOpenShareCode, queryShareCode} from "../../api/system/sys_sharecode";
import {MessageBox} from "mint-ui";
import {Dialog} from "vant";
import {getOneLever, getTwoLever} from "../../api/system/sys_user";
import { getTips } from "../../api/system/sys_config";
import { mixins } from '../../mixins/mixins';

export default {
  name: "ShareMakeMoney",
  mixins: [mixins],
  components: {
    vueQr
  },
  data() {
    return {
      selected: "1",
      imageUrl: require("../../assets/logo.png"),
      InviteCodeStr: "",
      inviteCode: "",
      inviteCodeUrl: "https://ai.weiquanai.com/register?sharecode=",
      text:"",
      invildTime: "2021-04-14 00:00:00",
      appealTime: "2021-04-14 00:00:00",
      taskNumbers: "0",
      oneLevers: [],
      twoLevers: [],
      oneLeverLoading: false,
      twoLeverLoading: false,
      shareTips: "",
    }
  },
  mounted() {
    this.$emit("titleChange", "分享码");
    queryShareCode().then(res=>{
      if (res.success){
        this.inviteCode = res.data;
        this.InviteCodeStr = "请您输入邀请码:" + this.inviteCode + "。请点击复制链接" + this.inviteCodeUrl + this.inviteCode + "到浏览器打开注册";
        this.text = this.inviteCodeUrl + this.inviteCode;
      }
    });
    getTips().then((res) => {
      if (res.success) {
        this.shareTips = res.data.share_text;
      }
    });
  },
  watch: {
    selected(val) {
      if (val == "2" && this.twoLevers.length === 0) {
        this.twoLeverLoading = true;
        getTwoLever().then(res => {
          if (res.success){
            this.twoLevers = res.data !=null?res.data: [];
          }
        }).finally(() => {
          this.twoLeverLoading = false;
        });
      }
    },
  },
  methods: {
    tabChange(name, title){
      console.log(name, title)
      if (name == 1){
        // 点击"我的推荐"：默认选中一级列表，开始加载
        this.selected = "1";
        this.oneLeverLoading = true;
        getOneLever().then(res => {
          if (res.success){
            this.oneLevers = res.data !=null?res.data: [];
          }
        }).finally(() => {
          this.oneLeverLoading = false;
        });
      }
    },
    handleRefrash() {
      console.log("handleRefrash")
    },
    onCopy(e) {
      alert('复制成功！: ' + e.text)
    },
    onError(e) {
      alert('你的浏览器不支持复制拷贝！')
    }
  }
}
</script>

<style lang="scss" scoped>
.selectTab /deep/ .van-tabs--line {
  height: 60px;
}

.selectTab /deep/ .van-tabs__wrap {
  height: 60px;
}

.selectTab /deep/ .van-tabs__nav {
  height: 60px;
}

.header {
  line-height: 33px;
  border-bottom: 1px dashed #acacac;
}

.tab-content-wrapper {
  position: relative;
  min-height: 80px;
}

.benefit-loading-mask {
  position: absolute;
  inset: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(255, 255, 255, 0.7);
  z-index: 1;
}
</style>
